import { RestResource } from '../rest'

import { KNOWLEDGE_SERVER } from '../server'

const keyword = new RestResource({server: KNOWLEDGE_SERVER, resource: 'keyword'});

export default keyword;